export const ANIMALS_IMPORT = "animal";
export const ACTIVITIES_IMPORT = "activity";

export const BCMS_SLUG = "BCMS";
export const TRU_TEST_SLUG = "TRU_TEST";
export const FARMPLAN_SLUG = "FARMPLAN";
export const APHIS_SLUG = "APHIS";
